"use strict";
/* IMPORT */
Object.defineProperty(exports, "__esModule", { value: true });
const consts_1 = require("./consts");
const is_proxy_1 = require("./is_proxy");
function record(proxy, fn) {
    if (Array.isArray(proxy) && !is_proxy_1.default(proxy)) {
        const paths = new Map(), { length } = proxy;
        for (let i = 0; i < length; i++) {
            proxy[i][consts_1.$GET_RECORD_START];
        }
        fn.apply(undefined, proxy);
        for (let i = 0; i < length; i++) {
            paths.set(proxy[i], proxy[i][consts_1.$GET_RECORD_STOP]);
        }
        return paths;
    }
    else {
        proxy[consts_1.$GET_RECORD_START];
        fn(proxy); //TSC
        return proxy[consts_1.$GET_RECORD_STOP];
    }
}
/* EXPORT */
exports.default = record;
